export const header = "#000000";
export const navbar = "#000000";
export const lightText = "#4f4c4c";
export const darkText = "#000000";
export const lightButton = "#eeecff";
export const darkButton = "#ffcd24 ";
export const dimBackground = "#e6e3e3";
export const lightBackground = "#403e3e";
export const darkBackground = "#303030";
export const white = "#ffffff";
export const yellowGold = "#ffc800";

// SGI APP COLORS THEME

const navbarAll = "#ffffff"
const darkAll = "#000000"
const secondColorAll = "#27b88b"

//theme color for Brand Invoice
export const brandName = "Tutors Expert";
export const brandUrl = "britishpaperspro.co.uk";

// export const navbar = navbarAll;
export const navbarText = darkAll;
// export const lightText = navbarAll;
export const mainBackgound = darkAll;
export const invoiceCard = "#e1e2e6";
export const button = "#e9da29";
export const cardBackground = "#e1e2e6";

